module.exports = __webpack_public_path__ + "static/img/list2.0ba4032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/list2.png
// module id = zj9A
// module chunks = 0